<breadcrumb endText="Exam List" />
<div class="p-2 lg:pb-2 lg:m-5">
  @if (showOwnerPopup || openEditors || openEditTimeDialog || openActionInfoDialog) {
  <div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
    <div class="h-full w-full flex justify-center items-center">
      <div class="bg-white rounded-[8px] absolute min-w-[450px]">
        @if (showOwnerPopup) {
        <div class="p-4 flex flex-col gap-4">
          <div>
            <div class="text-sm mb-6">
              Current Owner is <b>{{changeOwnerDisplayName}}</b>
            </div>
            <p class="text-sm font-semibold">
              New Owner
            </p>
            <div class="relative">
              <search-input containerClass="w-full mt-2 mb-1" [(searchText)]="searchText"
                (searchTextChange)="debounceSearch()" />
              @if (showDropdown) {
              <div class="dropdown shadow w-full flex flex-col absolute top-full overflow-y-auto mt-2">
                @for (user of foundUsers; track user; let i = $index) {
                <button aria-label="Select user" (click)="selectUser(i)"
                  [ngClass]="user.isSelected?
                        'group flex flex-row bg-gray-300 rounded-[8px] p-1 justify-between items-center transition duration-200':
                        'group flex flex-row hover:bg-gray-200 rounded-[8px] p-1 justify-between items-center transition duration-200'">
                  {{user.name}}
                  <span class="text-xs text-transparent group-hover:text-gray-600 transition duration-200">
                    {{user.username}}
                  </span>
                </button>
                }
              </div>
              }
            </div>
          </div>

          <div class="flex justify-end">
            <!-- TODO need to figure out th ui role to show and hide the force button -->
            <outline-button [marginRight]="true" text="Cancel" (click)="cancelOwnerChange()" />
            @if (currentUserName.includes(changeOwnerDisplayName)) {
            <full-button text="Save" [marginRight]="true" (click)="saveOwnerChange()" />
            }
            @if (!currentUserName.includes(changeOwnerDisplayName)) {
            <clear-button text="Force" (click)="saveOwnerChange(true)" />
            }
          </div>
        </div>
        }
        @if (openEditors) {
        <div class="p-4 flex flex-col gap-2">
          <div class="flex justify-between items-center">
            <b>Editors</b>
            <clear-button text="Close" (click)="openEditors = false" />
          </div>
          <div class="relative">
            <search-input containerClass="w-full mt-2 mb-1" [(searchText)]="searchText"
              (searchTextChange)="debounceSearch()" />
            @if (foundUsers.length > 0 && showDropdown) {
            <div class="dropdown shadow w-full flex flex-col absolute top-full overflow-y-auto" (focusout)="onBlur()">
              @for (user of foundUsers; track user; let i = $index) {
              <button (click)="addToAddEditorList(user)"
                [ngClass]="user.isSelected?
                        'group flex flex-row bg-gray-300 rounded-[8px] p-1 justify-between items-center transition duration-200':
                        'group flex flex-row hover:bg-gray-200 rounded-[8px] p-1 justify-between items-center transition duration-200'">
                {{user.name}}
                <span class="text-xs text-transparent group-hover:text-gray-600 transition duration-200">
                  {{user.username}}
                </span>
              </button>
              }
            </div>
            }
            @for (editor of editorsToAdd; track editor) {
            <div class="p-1 rounded-[6px] grid grid-cols-3 w-full hover:bg-gray-200">
              <div></div>
              {{editor.display_name}}
              <button aria-label="Add Editor" class="text-[#1AC69C] hover:bg-[#BAEDE1] rounded-[6px] mx-1"
                (click)="addEditor(editor)">
                <fa-icon [icon]="faPlus" />
              </button>
            </div>
            }
            @for (editor of currentEditors; track editor) {
            <div>
              @if (editor.connection !== 'owner') {
              <div class="p-1 rounded-[6px] grid grid-cols-3 w-full hover:bg-gray-200">
                <button aria-label="Remove Editor" class="text-[#A10404] hover:bg-[#ECCCCC] rounded-[6px] mx-1"
                  (click)="removeEditor(editor)">
                  <fa-icon [icon]="faXmark" />
                </button>
                {{editor.display_name}}
                <div></div>
              </div>
              }
            </div>
            }
          </div>
        </div>
        }
        @if (openEditTimeDialog && editTimeItem) {
        <div class="p-4">
          <b>Edit time for {{editTimeItem.exam_title}}</b>
          <div class="my-2 flex justify-evenly gap-4">
            <div>
              <label class="block text-sm leading-6 text-gray-900 font-medium">
                Last Start:
              </label>
              <input (ngModelChange)="editTimeItem.latest_start = $event"
                [ngModel]="editTimeItem.latest_start | date:'yyyy-MM-ddTHH:mm'" type="datetime-local"
                class="block rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6"
                ngModel />
            </div>
            <div>
              <label class="block flex-grow text-sm leading-6 text-gray-900 font-medium">
                Finsh By:
              </label>
              <input (ngModelChange)="editTimeItem.last_finish = $event"
                [ngModel]="editTimeItem.last_finish | date:'yyyy-MM-ddTHH:mm'" type="datetime-local"
                class="block flex-grow rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6" />
            </div>
          </div>
          <div class="flex justify-even gap-[6px] mt-[16px]">
            <button
              class="w-[218px] rounded-[6px] border border-[#CC0033] text-[#CC0033] py-[4px] hover:border-[#940025] hover:bg-[#F2EFFE] hover:text-[#940025]"
              (click)="openEditTimeDialog = false">
              Cancel
            </button>
            <button class="w-[218px] rounded-[6px] bg-[#CC0033] hover:bg-[#940025] text-white py-[4px]"
              (click)="saveEditExamTime()">
              Save
            </button>
          </div>
        </div>
        }
        @if (openActionInfoDialog) {
        <div class="p-4 max-w-[500px] flex flex-col gap-4">
          <div class="flex justify-between items-center">
            <h1 class="text-lg"><b>States of an Exam</b></h1>
            <button aria-label="Close" (click)="openActionInfoDialog = false"
              class="mr-1 text-slate-700 rounded-full py-1 px-2 hover:bg-gray-200">
              <fa-icon [icon]="faXmark" />
            </button>
          </div>
          <ul class="list-disc px-4">
            <li><b class="font-semibold">Draft:</b> The exam is being created and is not yet ready for review.</li>
            <li><b class="font-semibold">Ready:</b> The exam is filled with the necessary information and is ready for
              review.</li>
            <li><b class="font-semibold">Active:</b> The exam is currently active and available for students to take.
            </li>
          </ul>
          <div class="flex justify-center gap-1 items-center">
            <div class="bg-[#E31717] text-white rounded-lg px-2 py-1">Draft</div> >
            <div class="bg-[#FFC839] text-white rounded-lg px-2 py-1">Ready</div> >
            <div class="bg-[#118D57] text-white rounded-lg px-2 py-1">Active</div>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
  }
  @if (showDeleteDialog) {
  <app-delete-confirmation [message]="'Are you sure you want to delete this exam?'" (confirm)="confirmDelete()"
    (cancel)="cancelDelete()">
  </app-delete-confirmation>
  }
  <h1 class="text-xl font-semibold">
    {{is_classroom? 'Assessments' : 'Exams'}}
  </h1>
  <div class="lg:flex lg:justify-between lg:items-center mb- my-[24px]">
    <div class="flex flex-col gap-2">
      <div class="text-[14px] flex w-full">
        <button (click)="switchToMyExams()"
          [ngClass]="examTabs === tabs.my_exams? 'flex items-center px-[20px] py-[12px] border-b border-b-black rounded-t-[8px] hover:bg-gray-200':'flex items-center px-[20px] py-[12px] text-[#74808BB2] border-b border-b-[#74808BB2] rounded-t-[8px] hover:bg-gray-200'">
          @if (examTabs !== tabs.my_exams) {
          <svg class="mr-[12px]" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
            fill="none">
            <path
              d="M4 20C3.45 20 2.97933 19.8043 2.588 19.413C2.19667 19.0217 2.00067 18.5507 2 18V6C2 5.45 2.196 4.97933 2.588 4.588C2.98 4.19667 3.45067 4.00067 4 4H10L12 6H20C20.55 6 21.021 6.196 21.413 6.588C21.805 6.98 22.0007 7.45067 22 8V18C22 18.55 21.8043 19.021 21.413 19.413C21.0217 19.805 20.5507 20.0007 20 20H4ZM4 18H20V8H11.175L9.175 6H4V18Z"
              fill="#74808B" />
          </svg>
          }
          @if (examTabs === tabs.my_exams) {
          <svg class="mr-[12px]" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
            fill="none">
            <path
              d="M4 20C3.45 20 2.97933 19.8043 2.588 19.413C2.19667 19.0217 2.00067 18.5507 2 18V6C2 5.45 2.196 4.97933 2.588 4.588C2.98 4.19667 3.45067 4.00067 4 4H9.175C9.44167 4 9.696 4.05 9.938 4.15C10.18 4.25 10.3923 4.39167 10.575 4.575L12 6H20C20.55 6 21.021 6.196 21.413 6.588C21.805 6.98 22.0007 7.45067 22 8V18C22 18.55 21.8043 19.021 21.413 19.413C21.0217 19.805 20.5507 20.0007 20 20H4ZM4 18H20V8H11.175L9.175 6H4V18Z"
              fill="black" />
          </svg>
          }
          {{is_classroom? 'My Assessments' : 'My Exams'}}
        </button>
        <button (click)="switchToNonActiveExams()"
          [ngClass]="examTabs === tabs.non_active_exams? 'flex items-center px-[20px] py-[12px] border-b border-b-black rounded-t-[8px] hover:bg-gray-200':'flex items-center px-[20px] py-[12px] text-[#74808BB2] border-b border-b-[#74808BB2] rounded-t-[8px] hover:bg-gray-200'">
          @if (examTabs !== tabs.non_active_exams) {
          <svg class="mr-[12px]" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 21 20"
            fill="none">
            <path
              d="M17 0C17.2652 0 17.5196 0.105357 17.7071 0.292893C17.8946 0.48043 18 0.734784 18 1V4.757L16 6.757V2H2V18H16V15.242L18 13.242V19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H1C0.734784 20 0.48043 19.8946 0.292893 19.7071C0.105357 19.5196 0 19.2652 0 19V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H17ZM18.778 6.808L20.192 8.222L12.414 16L10.998 15.998L11 14.586L18.778 6.808ZM10 10V12H5V10H10ZM13 6V8H5V6H13Z"
              fill="#74808B" />
          </svg>
          }
          @if (examTabs === tabs.non_active_exams) {
          <svg class="mr-[12px]" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 21 20"
            fill="none">
            <path
              d="M17 0C17.2652 0 17.5196 0.105357 17.7071 0.292893C17.8946 0.48043 18 0.734784 18 1V4.757L16 6.757V2H2V18H16V15.242L18 13.242V19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H1C0.734784 20 0.48043 19.8946 0.292893 19.7071C0.105357 19.5196 0 19.2652 0 19V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H17ZM18.778 6.808L20.192 8.222L12.414 16L10.998 15.998L11 14.586L18.778 6.808ZM10 10V12H5V10H10ZM13 6V8H5V6H13Z"
              fill="black" />
          </svg>
          }
          Drafts
        </button>
        <button (click)="switchToActiveExams()"
          [ngClass]="examTabs === tabs.active_exams? 'flex items-center px-[20px] py-[12px] border-b border-b-black rounded-t-[8px] hover:bg-gray-200':'flex items-center px-[20px] py-[12px] text-[#74808BB2] border-b border-b-[#74808BB2] rounded-t-[8px] hover:bg-gray-200'">
          @if (examTabs !== tabs.active_exams) {
          <svg class="mr-[12px]" xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22"
            fill="none">
            <g clip-path="url(#clip0_7_553)">
              <path
                d="M18.5294 22H0V1H14.2059V3.1H1.85294V19.9H17.2941V12.2H19.1471V22H18.5294ZM3.45882 11.1325L4.85393 9.55137L9.04004 14.2956L19.6018 2.32562L21 3.90325L9.04004 17.4579L3.45882 11.1325Z"
                fill="#74808B" />
            </g>
            <defs>
              <clipPath id="clip0_7_553">
                <rect width="24" height="21" fill="white" transform="translate(0 0.5)" />
              </clipPath>
            </defs>
          </svg>
          }
          @if (examTabs === tabs.active_exams) {
          <svg class="mr-[12px]" xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22"
            fill="none">
            <g clip-path="url(#clip0_7_553)">
              <path
                d="M18.5294 22H0V1H14.2059V3.1H1.85294V19.9H17.2941V12.2H19.1471V22H18.5294ZM3.45882 11.1325L4.85393 9.55137L9.04004 14.2956L19.6018 2.32562L21 3.90325L9.04004 17.4579L3.45882 11.1325Z"
                fill="black" />
            </g>
            <defs>
              <clipPath id="clip0_7_553">
                <rect width="24" height="21" fill="white" transform="translate(0 0.5)" />
              </clipPath>
            </defs>
          </svg>
          }
          {{is_classroom? 'Ready Assessments' : 'Ready Exams'}}
        </button>
        <button (click)="switchToOpenExams()"
          [ngClass]="examTabs === tabs.opened_exams? 'flex items-center px-[20px] py-[12px] border-b border-b-black rounded-t-[8px] hover:bg-gray-200':'flex items-center px-[20px] py-[12px] text-[#74808BB2] border-b border-b-[#74808BB2] rounded-t-[8px] hover:bg-gray-200'">
          @if (examTabs !== tabs.opened_exams) {
          <svg xmlns="http://www.w3.org/2000/svg" class="mr-[12px]" width="24" height="24" viewBox="0 0 24 24"
            fill="none">
            <path
              d="M19.903 8.586C19.8555 8.4775 19.7892 8.37829 19.707 8.293L13.707 2.293C13.6217 2.21083 13.5225 2.14447 13.414 2.097C13.384 2.083 13.352 2.075 13.32 2.064C13.2363 2.03563 13.1492 2.01848 13.061 2.013C13.04 2.011 13.021 2 13 2H6C4.897 2 4 2.897 4 4V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V9C20 8.979 19.989 8.96 19.987 8.938C19.9815 8.84979 19.9644 8.7627 19.936 8.679C19.9267 8.647 19.9157 8.616 19.903 8.586ZM16.586 8H14V5.414L16.586 8ZM6 20V4H12V9C12 9.26522 12.1054 9.51957 12.2929 9.70711C12.4804 9.89464 12.7348 10 13 10H18L18.002 20H6Z"
              fill="#74808B" />
            <path d="M8 12H16V14H8V12ZM8 16H16V18H8V16ZM8 8H10V10H8V8Z" fill="#74808B" />
          </svg>
          }
          @if (examTabs === tabs.opened_exams) {
          <svg class="mr-[12px]" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
            fill="none">
            <path
              d="M19.903 8.586C19.8555 8.4775 19.7892 8.37829 19.707 8.293L13.707 2.293C13.6217 2.21083 13.5225 2.14447 13.414 2.097C13.384 2.083 13.352 2.075 13.32 2.064C13.2363 2.03563 13.1492 2.01848 13.061 2.013C13.04 2.011 13.021 2 13 2H6C4.897 2 4 2.897 4 4V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V9C20 8.979 19.989 8.96 19.987 8.938C19.9815 8.84979 19.9644 8.7627 19.936 8.679C19.9267 8.647 19.9157 8.616 19.903 8.586ZM16.586 8H14V5.414L16.586 8ZM6 20V4H12V9C12 9.26522 12.1054 9.51957 12.2929 9.70711C12.4804 9.89464 12.7348 10 13 10H18L18.002 20H6Z"
              fill="black" />
            <path d="M8 12H16V14H8V12ZM8 16H16V18H8V16ZM8 8H10V10H8V8Z" fill="black" />
          </svg>
          }
          {{is_classroom? 'Active Assessments' : 'Active Exams'}}
        </button>
      </div>
    </div>
    <div class="flex justify-end mt-2 lg:mt-0">
      <button
        class="text-[14px] font-semibold px-[16px] text-white py-[12px] rounded-[8px] bg-[#CC0033] hover:bg-[#940025]"
        (click)="router.navigate(['dashboard/exam/create'])">
        Create Exam
        <fa-icon [icon]="faAdd" class="ml-[8px]" />
      </button>
    </div>
  </div>
  <div class="flex items-center justify-between">
    <!-- TODO re-add this type dropdown oncce we have the endpoint ready -->
    <!--<div class="flex items-center">
          <span *ngIf="!isMobile">
            Assessment Type:
          </span>
          <div class="ml-[12px]">
            <button (click)="showAssessmentTypeDropdown = !showAssessmentTypeDropdown" class="flex justify-between border rounded-[8px] border-[#BFC7CE] bg-[#FFF] px-[18px] py-[12px] w-[196px] hover:border-[#718293] hover:bg-[#D6DBE0]">
              {{assessmentTypeSelected}}
              <fa-icon [icon]="faChevronDown" />
            </button>
            <div *ngIf="showAssessmentTypeDropdown" class="assessmentTypeDropdown">
              <button (click)="switchAssessmentTypeSelected(AssessmentTypes.all_types)" class="hover:bg-[#F2EFFE] w-full flex items-center py-[6px] pl-[12px] group">
                <checkbox-circle [checked]="assessmentTypeSelected === AssessmentTypes.all_types" />
                {{AssessmentTypes.all_types}}
              </button>
              <button (click)="switchAssessmentTypeSelected(AssessmentTypes.exam)" class="hover:bg-[#F2EFFE] w-full flex items-center py-[6px] pl-[12px] group">
                <checkbox-circle [checked]="assessmentTypeSelected === AssessmentTypes.exam" />
                {{AssessmentTypes.exam}}
              </button>
              <button (click)="switchAssessmentTypeSelected(AssessmentTypes.quiz)" class="hover:bg-[#F2EFFE] w-full flex items-center py-[6px] pl-[12px] group">
                <checkbox-circle [checked]="assessmentTypeSelected === AssessmentTypes.quiz" />
                {{AssessmentTypes.quiz}}
              </button>
              <button (click)="switchAssessmentTypeSelected(AssessmentTypes.homework)" class="hover:bg-[#F2EFFE] w-full flex items-center py-[6px] pl-[12px] group">
                <checkbox-circle [checked]="assessmentTypeSelected === AssessmentTypes.homework" />
                {{AssessmentTypes.homework}}
              </button>
            </div>
          </div>
        </div>-->
    <div class="flex gap-[12px]">
      <!-- TODO: re-add this filter button when we have filters ready for new backend endpoint -->
      <!--<div class="relative">
          <button (click)="openFilterDropdown = !openFilterDropdown" class="flex items-center rounded-[8px] border border-[#D0D5DD] text-[#344054] px-[16px] py-[10px] hover:border-[#718293] hover:bg-[#D6DBE0] text-sm font-medium gap-[8px]">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M5 10H15M2.5 5H17.5M7.5 15H12.5" stroke="#344054" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Filters
          </button>
          <div *ngIf="openFilterDropdown" class="filterDropdown w-full">
            Filter
          </div>
        </div>-->
      <search-input [(searchText)]="examSearchText" (searchTextChange)="debounceExamSearch()"
        containerClass="lg:w-[259px]" />
      @if (isSearchLoading && examResponse != null && examResponse.items.length > 0) {
      <div class="flex justify-center items-center">
        <dot-spinner />
      </div>
      }
    </div>
  </div>
  <table class="mt-4 w-full table-fixed border-separate border-spacing-0">
    <thead>
      <tr class="h-[48px] text-left text-gray-500 text-xs font-semibold uppercase leading-tight">
        <th scope="col" class="bg-[#F4F6F8] rounded-l-[4px] pl-[16px] lg:pl-[64px] pr-1 font-semibold">
          Title
        </th>
        @if (!isMobile) {
        <th scope="col" class="bg-[#F4F6F8] px-1 font-semibold">
          Timeframe
        </th>
        }
        @if (!isMobile) {
        <th scope="col" class="bg-[#F4F6F8] px-1 font-semibold">
          Author
        </th>
        }
        @if (!isMobile) {
        <th scope="col" class="bg-[#F4F6F8] px-1 font-semibold">
          Type
        </th>
        }
        <th scope="col" colspan="2" class="bg-[#F4F6F8] rounded-r-[4px] pl-1 pr-[16px] font-semibold">
          <div class="flex items-center gap-[4px]">
            Actions
            <button (click)="openActionInfoDialog = true" aria-label="Actions info" class="flex justify-center items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path
                  d="M6 8.5C6.14167 8.5 6.2605 8.452 6.3565 8.356C6.4525 8.26 6.50033 8.14133 6.5 8V6C6.5 5.85833 6.452 5.73967 6.356 5.644C6.26 5.54833 6.14133 5.50033 6 5.5C5.85867 5.49967 5.74 5.54767 5.644 5.644C5.548 5.74033 5.5 5.859 5.5 6V8C5.5 8.14167 5.548 8.2605 5.644 8.3565C5.74 8.4525 5.85867 8.50033 6 8.5ZM6 4.5C6.14167 4.5 6.2605 4.452 6.3565 4.356C6.4525 4.26 6.50033 4.14133 6.5 4C6.49967 3.85867 6.45167 3.74 6.356 3.644C6.26033 3.548 6.14167 3.5 6 3.5C5.85833 3.5 5.73967 3.548 5.644 3.644C5.54833 3.74 5.50033 3.85867 5.5 4C5.49967 4.14133 5.54767 4.26017 5.644 4.3565C5.74033 4.45283 5.859 4.50067 6 4.5ZM6 11C5.30833 11 4.65833 10.8687 4.05 10.606C3.44167 10.3433 2.9125 9.98717 2.4625 9.5375C2.0125 9.08783 1.65633 8.55867 1.394 7.95C1.13167 7.34133 1.00033 6.69133 1 6C0.999667 5.30867 1.131 4.65867 1.394 4.05C1.657 3.44133 2.01317 2.91217 2.4625 2.4625C2.91183 2.01283 3.441 1.65667 4.05 1.394C4.659 1.13133 5.309 1 6 1C6.691 1 7.341 1.13133 7.95 1.394C8.559 1.65667 9.08817 2.01283 9.5375 2.4625C9.98683 2.91217 10.3432 3.44133 10.6065 4.05C10.8698 4.65867 11.001 5.30867 11 6C10.999 6.69133 10.8677 7.34133 10.606 7.95C10.3443 8.55867 9.98817 9.08783 9.5375 9.5375C9.08683 9.98717 8.55767 10.3435 7.95 10.6065C7.34233 10.8695 6.69233 11.0007 6 11Z"
                  fill="#74808B" />
              </svg>
            </button>
          </div>
        </th>
      </tr>
    </thead>
  <tbody class="transition-opacity" [class.opacity-50]="isSearchLoading && examResponse != null && examResponse.items.length > 0">
    @for (item of (examResponse != null ? examResponse.items : []); track item) {
    <tr class="hover:bg-[#F9FAFB] transition-colors">
      <td class="pl-[16px] lg:pl-[64px] pr-1 py-3 align-middle border-b border-[#F1F3F5] text-sm">
        <button type="button" (click)="previewExam(item.exam_id)"
          class="block max-w-full truncate text-left font-medium text-black/90 hover:text-rutgers-red hover:underline">
          {{item.exam_title}}
        </button>
      </td>
      @if (!isMobile) {
      <td class="px-1 py-3 align-middle border-b border-[#F1F3F5]">
        <div class="grid grid-cols-6 text-gray-600 text-sm">
          <span class="font-medium">Start: </span>
          @if (item.timeframe != null && item.timeframe.first_start != null) {
          <span class="col-span-5">{{item.timeframe.first_start | date: 'short'}}</span>
          } @else {
          <span class="col-span-5 text-gray-400">—</span>
          }
        </div>
        <div class="grid grid-cols-6 text-gray-600 text-sm">
          <span class="font-medium">Due: </span>
          @if (item.timeframe != null && item.timeframe.last_start != null) {
          <span class="col-span-5">{{item.timeframe.last_start | date: 'short'}}</span>
          } @else {
          <span class="col-span-5 text-gray-400">—</span>
          }
        </div>
      </td>
      }
      @if (!isMobile) {
      <td class="px-1 py-3 align-middle border-b border-[#F1F3F5] text-black/90 text-sm truncate">
        {{item.author_name}}
      </td>
      }
      @if (!isMobile) {
      <td class="px-1 py-3 align-middle border-b border-[#F1F3F5] text-gray-600 text-sm truncate">
        {{item.type}}
      </td>
      }
      <td class="px-1 py-3 align-middle border-b border-[#F1F3F5]">
        <div
          class="p-0.5 rounded-lg outline outline-1 outline-offset-[-1px] outline-neutral-300 inline-flex justify-evenly items-start text-xs gap-0.5">
          @if (!item.open && (examAdmin || item.isEditor || item.isAuthor)) {
          <button [disabled]="!item.open  && !item.active" (click)="toggleActivateExam(item, false)"
            [ngClass]="!item.open  && !item.active? 'bg-[#E31717] text-white rounded-lg px-[12px] py-[6px] grow': 'rounded-lg px-[12px] py-[6px] hover:bg-gray-200 grow'">
            Draft
          </button>
          }
          @if (!item.open && (examAdmin || item.isEditor || item.isAuthor)) {
          <button [disabled]="item.active && !item.open" (click)="toggleActivateExam(item, true)"
            [ngClass]="item.active && !item.open? 'bg-[#FFC839] text-white rounded-lg px-[12px] py-[6px] grow': 'rounded-lg px-[12px] py-[6px] hover:bg-gray-200 grow'">
            Ready
          </button>
          }
          @if (item.open && examAdmin) {
          <button (click)="openExam(item.exam_id, item.active, false)"
            [ngClass]="!item.active? 'bg-[#E31717] text-white rounded-lg px-[12px] py-[6px] grow': 'rounded-lg px-[12px] py-[6px] hover:bg-gray-200 grow'">
            Close
          </button>
          }
          @if ((item.active || item.open) && examAdmin) {
          <button (click)="openExam(item.exam_id, item.active, true)" [disabled]="item.open && item.active"
            [ngClass]="item.open && item.active? 'bg-[#118D57] text-white rounded-lg px-[12px] py-[6px] grow': 'rounded-lg px-[12px] py-[6px] hover:bg-gray-200 grow'">
            Active
          </button>
          }
        </div>
      </td>
      <td class="pl-1 pr-[16px] py-3 align-middle border-b border-[#F1F3F5]">
        <div class="flex gap-[8px]">
          <button (click)="previewExam(item.exam_id)" aria-label="Preview Exam" tooltip="Preview Exam">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 22 18" fill="none">
              <path
                d="M2.275 12.296C1.425 11.192 1 10.639 1 9C1 7.36 1.425 6.809 2.275 5.704C3.972 3.5 6.818 1 11 1C15.182 1 18.028 3.5 19.725 5.704C20.575 6.81 21 7.361 21 9C21 10.64 20.575 11.191 19.725 12.296C18.028 14.5 15.182 17 11 17C6.818 17 3.972 14.5 2.275 12.296Z"
                stroke="#637381" stroke-width="1.5" />
              <path
                d="M14 9C14 9.79565 13.6839 10.5587 13.1213 11.1213C12.5587 11.6839 11.7956 12 11 12C10.2044 12 9.44129 11.6839 8.87868 11.1213C8.31607 10.5587 8 9.79565 8 9C8 8.20435 8.31607 7.44129 8.87868 6.87868C9.44129 6.31607 10.2044 6 11 6C11.7956 6 12.5587 6.31607 13.1213 6.87868C13.6839 7.44129 14 8.20435 14 9Z"
                stroke="#637381" stroke-width="1.5" />
            </svg>
          </button>
          <button (click)="cloneExam(item.exam_id)" aria-label="Clone Exam" tooltip="Clone Exam">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M14 16.75H6C5.27065 16.75 4.57118 16.4603 4.05546 15.9445C3.53973 15.4288 3.25 14.7293 3.25 14V6C3.25 5.27065 3.53973 4.57118 4.05546 4.05546C4.57118 3.53973 5.27065 3.25 6 3.25H14C14.7293 3.25 15.4288 3.53973 15.9445 4.05546C16.4603 4.57118 16.75 5.27065 16.75 6V14C16.75 14.7293 16.4603 15.4288 15.9445 15.9445C15.4288 16.4603 14.7293 16.75 14 16.75ZM6 4.75C5.66848 4.75 5.35054 4.8817 5.11612 5.11612C4.8817 5.35054 4.75 5.66848 4.75 6V14C4.75 14.3315 4.8817 14.6495 5.11612 14.8839C5.35054 15.1183 5.66848 15.25 6 15.25H14C14.3315 15.25 14.6495 15.1183 14.8839 14.8839C15.1183 14.6495 15.25 14.3315 15.25 14V6C15.25 5.66848 15.1183 5.35054 14.8839 5.11612C14.6495 4.8817 14.3315 4.75 14 4.75H6Z"
                fill="#637381" />
              <path
                d="M18 20.75H10C9.27065 20.75 8.57118 20.4603 8.05546 19.9445C7.53973 19.4288 7.25 18.7293 7.25 18V16H8.75V18C8.75 18.3315 8.8817 18.6495 9.11612 18.8839C9.35054 19.1183 9.66848 19.25 10 19.25H18C18.3315 19.25 18.6495 19.1183 18.8839 18.8839C19.1183 18.6495 19.25 18.3315 19.25 18V10C19.25 9.66848 19.1183 9.35054 18.8839 9.11612C18.6495 8.8817 18.3315 8.75 18 8.75H16V7.25H18C18.7293 7.25 19.4288 7.53973 19.9445 8.05546C20.4603 8.57118 20.75 9.27065 20.75 10V18C20.75 18.7293 20.4603 19.4288 19.9445 19.9445C19.4288 20.4603 18.7293 20.75 18 20.75Z"
                fill="#637381" />
            </svg>
          </button>
          @if ((item.isAuthor || item.isEditor) && (!item.active && !item.open)) {
          <button (click)="editExam(item.exam_id)" aria-label="Edit Exam" tooltip="Edit Exam">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M17.7586 5.73201L14.268 2.24061C14.1519 2.1245 14.0141 2.0324 13.8624 1.96957C13.7107 1.90673 13.5482 1.87439 13.384 1.87439C13.2198 1.87439 13.0572 1.90673 12.9056 1.96957C12.7539 2.0324 12.6161 2.1245 12.5 2.24061L2.86641 11.875C2.74983 11.9906 2.65741 12.1283 2.59451 12.28C2.5316 12.4317 2.49948 12.5944 2.50001 12.7586V16.25C2.50001 16.5815 2.6317 16.8994 2.86612 17.1339C3.10054 17.3683 3.41849 17.5 3.75001 17.5H7.24141C7.40563 17.5005 7.5683 17.4684 7.71999 17.4055C7.87168 17.3426 8.00935 17.2502 8.12501 17.1336L17.7586 7.49998C17.8747 7.3839 17.9668 7.24609 18.0296 7.09442C18.0925 6.94274 18.1248 6.78017 18.1248 6.616C18.1248 6.45182 18.0925 6.28925 18.0296 6.13758C17.9668 5.9859 17.8747 5.84809 17.7586 5.73201ZM7.24141 16.25H3.75001V12.7586L10.625 5.88358L14.1164 9.37498L7.24141 16.25ZM15 8.49061L11.5086 4.99998L13.3836 3.12498L16.875 6.61561L15 8.49061Z"
                fill="#637381" />
            </svg>
          </button>
          }
          @if (item.isAuthor && !item.open) {
          <button (click)="openDeleteExamDialog(item.exam_id)" aria-label="Delete Exam" tooltip="Delete Exam">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
              <path
                d="M3 18C2.45 18 1.97933 17.8043 1.588 17.413C1.19667 17.0217 1.00067 16.5507 1 16V3H0V1H5V0H11V1H16V3H15V16C15 16.55 14.8043 17.021 14.413 17.413C14.0217 17.805 13.5507 18.0007 13 18H3ZM13 3H3V16H13V3ZM5 14H7V5H5V14ZM9 14H11V5H9V14Z"
                fill="#CC0033" />
            </svg>
          </button>
          }
          @if (item.menuItems.length > 0) {
          <dropdown-menu [menuItems]="item.menuItems" aria-label="Exam Menu" appearance="outlined" [showOutline]="false" />
          }
        </div>
      </td>
    </tr>
    } @empty {
    <tr>
      <td colspan="6" class="py-10 text-center text-sm text-gray-500">
        @if (isSearchLoading || examResponse == null) {
        <div class="flex justify-center">
          <dot-spinner />
        </div>
        } @else if (examSearchText) {
        No exams match "{{examSearchText}}"
        } @else if (!activeFilter) {
        No exams you own
        } @else {
        No exams to show
        }
      </td>
    </tr>
    }
  </tbody>
  </table>
  <full-length-pagination [(currentPagination)]="currentPagination" perPageText="Exams"
    (paginationService)="handlePaginationChange()" />
</div>